import ExcelJS from 'exceljs';
import FileSaver  from 'file-saver';
import {breakTitle} from "../../../Custom/Custom";

/** 0-based column index to Excel column letter (0=A, 26=AA) */
function getColumnLetter(colIndex) {
  let s = '';
  let n = colIndex + 1;
  while (n > 0) {
    const r = (n - 1) % 26;
    s = String.fromCharCode(65 + r) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}




  
export const generateExcelIIP = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();

  const writeSimpleSheet = (sheetSpec) => {
    const sheet = workbook.addWorksheet(sheetSpec.sheetName);
    const worksheet = excelHeader(sheet, sheetSpec);

    worksheet.mergeCells(sheetSpec.fifthRowMergeCells);
    const fifthHeaderRow = worksheet.getRow(5);
    fifthHeaderRow.getCell(1).value = sheetSpec.fifthRowText;
    fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
    fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    fifthHeaderRow.height = 20;
    fifthHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    // excel English Column
    const headerRow3 = worksheet.addRow(sheetSpec.headerEnglishColumns);
    headerRow3.height = 50;
    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 30;
    });

    (sheetSpec.excelRowData || []).forEach((row) => {
      const dataRow = worksheet.addRow(row);
      dataRow.height = null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = { name: 'SansSerif', size: 10 };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') isTotalRow = true;
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });
  };

  // Backward compatible: single sheet OR multiple sheets
  if (Array.isArray(excelObjectData?.sheets) && excelObjectData.sheets.length > 0) {
    excelObjectData.sheets.forEach((s) => writeSimpleSheet({ ...excelObjectData, ...s }));
  } else {
    writeSimpleSheet(excelObjectData);
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




// Create Excel Header *******************
const excelHeader=(worksheet,excelObjectData)=>{


    //First Row Design and Merge cells A1:K1
    worksheet.mergeCells(excelObjectData.firstRowMergeCells);
    const firstHeaderRow = worksheet.getRow(1);
    firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
    firstHeaderRow.getCell(1).font = {name: 'SansSerif'};
    firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
    firstHeaderRow.height = 15;
    firstHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };


    //Second Row Design and  Merge cells A2:K1
    worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
    const secondHeaderRow = worksheet.getRow(2);
    secondHeaderRow.getCell(1).value = excelObjectData.secondRowText
    secondHeaderRow.getCell(1).font = {name: 'SansSerif',size:18,color: { argb: 'ff7966' }};
    secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    secondHeaderRow.height = 30;
    secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

   //third Row Design and  Merge cells A2:K1
      worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
      const thirdHeaderRow = worksheet.getRow(3);
      thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
      thirdHeaderRow.getCell(1).font = { name: 'SansSerif',size:12,};
      thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
      thirdHeaderRow.height = 20;
      thirdHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };


 
    worksheet.mergeCells(excelObjectData.fourthRowMergeCells); 
    const fourthHeaderRow = worksheet.getRow(4);
    fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
    fourthHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:10};
    fourthHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
    fourthHeaderRow.height = 20;
    fourthHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    return worksheet;


}



// IIp Mining Report ***********************
export const iipMiningReport=async (excelObjectData)=>{
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  // First Row (Export Date)
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Second Row (Title)
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15, color: { argb: 'ff7966' } };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row (Subtitle)
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Fourth Row (Date or any other data)
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  // Excel English Columns Headers
  const headerRow1 = worksheet.addRow(excelObjectData.yearColumn);
  headerRow1.height = 25;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 15; 
    if(![1,2,3].includes(colNumber)){
      column.width = 25; 
    }
  });



  const headerRow2 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow2.height = 25;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 15;
    if(colNumber===1){
      column.width = 30;
    }
     // Adjust column width
  });

  // Merging Specific Cells for Sub-columns (if necessary)
  worksheet.mergeCells('A5:A6');
  worksheet.mergeCells('B5:B6');
  worksheet.mergeCells('C5:C6');

  // Previous-month / previous-year highlight fills (Excel only).
  // Defaults match screenshot: previous month = light blue, previous year = peach.
  const prevMonthHex = String(excelObjectData.previousMonthHighlightColor || 'ADD8E6').replace(/^#/, '').toUpperCase();
  const prevYearHex = String(excelObjectData.previousYearHighlightColor || 'FFE4B5').replace(/^#/, '').toUpperCase();
  const prevMonthArgb = prevMonthHex.length === 6 ? `FF${prevMonthHex}` : prevMonthHex;
  const prevYearArgb = prevYearHex.length === 6 ? `FF${prevYearHex}` : prevYearHex;
  const prevMonthFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevMonthArgb } };
  const prevYearFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevYearArgb } };

  // Dynamic merge for month groups (row 5 only).
  // Supports either uniform groupSize (legacy) or explicit per-month sizes via excelObjectData.monthGroupSizes.
  const mergeRowCount = Math.max(0, Number(excelObjectData.mergeRow) || 0);
  const explicitSizes = Array.isArray(excelObjectData.monthGroupSizes) ? excelObjectData.monthGroupSizes : null;
  const totalCols = Array.isArray(excelObjectData.yearColumn) ? excelObjectData.yearColumn.length : 0;
  const dynamicGroupSize = mergeRowCount > 0 ? Math.floor((Math.max(0, totalCols - 3)) / mergeRowCount) : 0;
  const uniformGroupSize = dynamicGroupSize > 0 ? dynamicGroupSize : 4; // fallback legacy
  let runningStartCol = 3; // 0-based, first month starts at col D (index 3)
  const groupRanges = []; // 1-based column ranges for applying fills to headers/data
  for (let i = 0; i < mergeRowCount; i++) {
    const groupSize = explicitSizes && explicitSizes[i] ? Number(explicitSizes[i]) : uniformGroupSize;
    const startCol = runningStartCol;
    const endCol = startCol + (groupSize - 1);
    const startLetter = getColumnLetter(startCol);
    const endLetter = getColumnLetter(endCol);
    const range = `${startLetter}5:${endLetter}5`;

    // ExcelJS throws if any cell in the target range is already part of a merged range.
    // Guard by checking the top-left cell; if it's already merged, skip this range.
    const topLeftCell = worksheet.getCell(5, startCol + 1); // (row, col) are 1-based
    if (!topLeftCell.isMerged) {
      worksheet.mergeCells(range);
    }

    // store month-group bounds (Excel columns are 1-based)
    groupRanges.push({ groupIndex: i, startCol1: startCol + 1, endCol1: endCol + 1 });
    runningStartCol = endCol + 1;
  }

  // Apply fills to header rows (row 5 & row 6) for previous month/year groups:
  // groupIndex 1 => previous month (blue), groupIndex 2 => previous year (peach)
  groupRanges.forEach(({ groupIndex, startCol1, endCol1 }) => {
    let fill = null;
    if (groupIndex === 1) fill = prevMonthFill;
    if (groupIndex === 2) fill = prevYearFill;
    if (!fill) return;
    for (let c = startCol1; c <= endCol1; c += 1) {
      worksheet.getCell(5, c).fill = fill;
      worksheet.getCell(6, c).fill = fill;
    }
  });



  // Excel Data Rows (optional boldFirstColLabels for General Index style multi-row highlights)
  const boldLabels = excelObjectData.boldFirstColLabels;
  // For General Index, sector headings can repeat in API rows; bold only the first occurrence.
  const seenBoldLabels = new Set();
  excelObjectData.excelRowData.forEach((row) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = 20;
    const rowLabel = row[0];
    const isReportNameRow = rowLabel === excelObjectData.reportName;
    const isBoldFirstOccurrence =
      Array.isArray(boldLabels) &&
      boldLabels.includes(rowLabel) &&
      !seenBoldLabels.has(rowLabel);
    const isHighlightRow = isReportNameRow || isBoldFirstOccurrence;

    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.value = value;

      // Apply fills to data cells for previous month/year groups.
      const col1 = index + 1;
      for (let gi = 0; gi < groupRanges.length; gi += 1) {
        const gr = groupRanges[gi];
        if (col1 >= gr.startCol1 && col1 <= gr.endCol1) {
          if (gr.groupIndex === 1) cell.fill = prevMonthFill;
          if (gr.groupIndex === 2) cell.fill = prevYearFill;
          break;
        }
      }

      // Default font
      let fontSize = 10;
      let isBold = false;
      if (isHighlightRow) {
        fontSize = 11;
        isBold = true;
        if (isBoldFirstOccurrence) {
          seenBoldLabels.add(rowLabel);
        }
      }

      // Variation % formatting (negative=red, positive=green, zero=blue)
      const strVal = typeof value === 'string' ? value.trim() : '';
      const isPercentLike = /^-?\d+(\.\d+)?%$/.test(strVal);
      let fontColorArgb = null;
      if (isPercentLike) {
        const numeric = parseFloat(strVal.replace('%', ''));
        if (numeric < 0) fontColorArgb = 'FFFF0000'; // Red
        else if (numeric > 0) fontColorArgb = 'FF00B050'; // Green
        else fontColorArgb = 'FF1E5EFF'; // Blue
      }

      cell.font = {
        name: 'SansSerif',
        size: fontSize,
        bold: isBold,
        ...(fontColorArgb ? { color: { argb: fontColorArgb } } : {}),
      };
    });
  });

  // Generate the Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}

/**
 * Single Excel with Current (GroupCodesCurrent) on top and Previous (GroupCodesPrevious) below.
 */
export const iipMiningReportCombined = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  const current = excelObjectData.current;
  const previous = excelObjectData.previous;
  const reportName = excelObjectData.reportName || 'MINING SECTOR';

  const totalCols = Math.max(
    (Array.isArray(current?.yearColumn) ? current.yearColumn.length : 0),
    (Array.isArray(previous?.yearColumn) ? previous.yearColumn.length : 0),
    12
  );
  const lastColLetter = getColumnLetter(totalCols - 1);

  // Rows 1-4: full width merge (dynamic columns for multi-month General / Mining)
  worksheet.mergeCells(`A1:${lastColLetter}1`);
  const r1 = worksheet.getRow(1);
  r1.getCell(1).value = excelObjectData.firstRowExportDate;
  r1.getCell(1).font = { name: 'SansSerif', size: 10 };
  r1.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  r1.height = 15;
  r1.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

  worksheet.mergeCells(`A2:${lastColLetter}2`);
  const r2 = worksheet.getRow(2);
  r2.getCell(1).value = excelObjectData.secondRowText;
  r2.getCell(1).font = { bold: true, name: 'SansSerif', size: 15, color: { argb: 'ff7966' } };
  r2.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  r2.height = 20;
  r2.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

  worksheet.mergeCells(`A3:${lastColLetter}3`);
  const r3 = worksheet.getRow(3);
  r3.getCell(1).value = excelObjectData.thirdRowText;
  r3.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  r3.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  r3.height = 20;
  r3.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

  worksheet.mergeCells(`A4:${lastColLetter}4`);
  const r4 = worksheet.getRow(4);
  r4.getCell(1).value = excelObjectData.fourthRowTextCurrent || 'MINING SECTOR';
  r4.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  r4.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  r4.height = 20;
  r4.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

  const writeSection = (section, startRow) => {
    const yearColumn = section.yearColumn;
    const headerEnglishColumns = section.headerEnglishColumns;
    const excelRowData = section.excelRowData;
    const mergeRowCount = Math.max(0, Number(section.mergeRow) || 0);
    const explicitSizes = Array.isArray(section.monthGroupSizes) ? section.monthGroupSizes : null;

    const headerRow1 = worksheet.getRow(startRow);
    yearColumn.forEach((val, i) => {
      const c = headerRow1.getCell(i + 1);
      c.value = breakTitle(val);
      c.font = { bold: true, name: 'SansSerif', size: 10 };
      c.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      c.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    headerRow1.height = 25;

    const headerRow2 = worksheet.getRow(startRow + 1);
    (headerEnglishColumns || []).forEach((val, i) => {
      const c = headerRow2.getCell(i + 1);
      c.value = breakTitle(val);
      c.font = { bold: true, name: 'SansSerif', size: 10 };
      c.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      c.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    headerRow2.height = 25;

    worksheet.mergeCells(`A${startRow}:A${startRow + 1}`);
    worksheet.mergeCells(`B${startRow}:B${startRow + 1}`);
    worksheet.mergeCells(`C${startRow}:C${startRow + 1}`);

    let offsetCols = 0;
    for (let i = 0; i < mergeRowCount; i++) {
      const groupSize = explicitSizes?.[i] || 4;
      const startCol = 3 + offsetCols;
      const s = getColumnLetter(startCol);
      const e = getColumnLetter(startCol + (groupSize - 1));
      const range = `${s}${startRow}:${e}${startRow}`;
      try {
        const topLeft = worksheet.getCell(startRow, startCol + 1);
        if (!topLeft.isMerged) worksheet.mergeCells(range);
      } catch (_) { /* skip */ }
      offsetCols += groupSize;
    }

    for (let col = 1; col <= (yearColumn || []).length; col++) {
      const column = worksheet.getColumn(col);
      column.width = col === 1 ? 30 : (col <= 3 ? 15 : 25);
    }

    const dataStartRow = startRow + 2;
    const boldLabelsCombined = excelObjectData.boldFirstColLabels;
    // For General Index, sector headings can repeat; bold only first occurrence.
    const seenBoldLabels = new Set();
    (excelRowData || []).forEach((row, rowIndex) => {
      const dataRow = worksheet.getRow(dataStartRow + rowIndex);
      const rowLabel = row[0];
      const isReportNameRow = rowLabel === reportName;
      const isBoldFirstOccurrence =
        Array.isArray(boldLabelsCombined) &&
        boldLabelsCombined.includes(rowLabel) &&
        !seenBoldLabels.has(rowLabel);
      const isHighlightRow = isReportNameRow || isBoldFirstOccurrence;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.value = value;

        // Default font
        let fontSize = 10;
        let isBold = false;
        if (isHighlightRow) {
          fontSize = 11;
          isBold = true;
          if (isBoldFirstOccurrence) {
            seenBoldLabels.add(rowLabel);
          }
        }

        // Variation % formatting (negative=red, positive=green, zero=blue)
        const strVal = typeof value === 'string' ? value.trim() : '';
        const isPercentLike = /^-?\d+(\.\d+)?%$/.test(strVal);
        let fontColorArgb = null;
        if (isPercentLike) {
          const numeric = parseFloat(strVal.replace('%', ''));
          if (numeric < 0) fontColorArgb = 'FFFF0000'; // Red
          else if (numeric > 0) fontColorArgb = 'FF00B050'; // Green
          else fontColorArgb = 'FF1E5EFF'; // Blue
        }

        cell.font = {
          name: 'SansSerif',
          size: fontSize,
          bold: isBold,
          ...(fontColorArgb ? { color: { argb: fontColorArgb } } : {}),
        };
      });
      dataRow.height = 20;
    });

    return dataStartRow + (excelRowData || []).length;
  };

  let nextRow = writeSection(current, 5);
  const labelRow = nextRow + 1;
  worksheet.mergeCells(`A${labelRow}:${lastColLetter}${labelRow}`);
  const labelCell = worksheet.getRow(labelRow).getCell(1);
  labelCell.value = 'Previous year data';
  labelCell.font = { bold: true, name: 'SansSerif', size: 12 };
  labelCell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
  worksheet.getRow(labelRow).height = 22;
  nextRow = labelRow + 1;
  writeSection(previous, nextRow);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

// General Index Report ***********************
export const generalIndexReport = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(excelObjectData.sheetName);
  const worksheet = excelHeader(sheet, excelObjectData);

  // Fifth Row Design and Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.firthRowMergeCells);
  const secondHeaderRow = worksheet.getRow(5);
  secondHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 10 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
  };

  // Excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 50;
  headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
      };

      const column = worksheet.getColumn(colNumber);
      if (colNumber === 1) {
          column.width = 28;
      } else if (colNumber === 4) {
          column.width = 20;
      } else {
          column.width = 15;
      }
  });

  // Excel Data Loop
  const highlightLabels = [
    'MINING SECTOR',
    'ELECTRICITY SECTOR',
    'MANUFACTURING SECTOR',
    'GENERAL INDEX',
  ];
  const seenBoldLabels = new Set();
  excelObjectData.excelRowData.forEach((row) => {
      const dataRow = worksheet.addRow(row);
      const rowLabel = row?.[0];
      const isFirstOccurrenceBold =
        highlightLabels.includes(rowLabel) && !seenBoldLabels.has(rowLabel);
      if (isFirstOccurrenceBold) seenBoldLabels.add(rowLabel);

      row.forEach((value, colIndex) => {
          const cell = dataRow.getCell(colIndex + 1);
          if (isFirstOccurrenceBold) {
              cell.font = { bold: true, name: 'SansSerif', size: 11 };
          } else {
              cell.font = { name: 'SansSerif', size: 10 };
          }

          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
          cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
          };
      });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
}


//*********** Monthly Pendecy Report ***************/


export const generateMonthlyPendencyReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  const firstSize = 50;
  const secondSize = 57;
  const thirdSize = 52;
  const fourthSize = 70;

  // First Row (Export Date)
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Second Row (Title)
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15, color: { argb: 'ff7966' } };
  if (excelObjectData.columnCount <= 12) {
    secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  } else {
    secondHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', indent: firstSize, wrapText: true};
  }
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row (Subtitle)
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  if (excelObjectData.columnCount <= 12) {
    thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  } else {
    thirdHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', indent: secondSize, wrapText: true};
  }
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Fourth Row (Date or any other data)
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  if (excelObjectData.columnCount <= 12) {
    fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  } else {
    fourthHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', indent: thirdSize, wrapText: true};
  }
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Fifth Row (Custom Text)
  if (excelObjectData.fifthRowText) {
    worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
    const fifthHeaderRow = worksheet.getRow(5);
    fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
    fifthHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
    if (excelObjectData.columnCount <= 12) {
      fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    } else {
      fifthHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', indent: fourthSize, wrapText: true};
    }
    fifthHeaderRow.height = 20;
    fifthHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  }

  // Excel English Columns Headers
  const headerRow1 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow1.height = 25;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 15; 
  });

    for (let i = 0; i < excelObjectData.monthlist.length; i++) {
      const startCol = excelObjectData.getExcelColumnName(2 + (i * 2));
      const endCol = excelObjectData.getExcelColumnName(3 + (i * 2));
      
      worksheet.mergeCells(`${startCol}6:${endCol}6`);
    }


  const headerRow2 = worksheet.addRow(excelObjectData.headerEnglishColumns1);
  headerRow2.height = 25;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });
  worksheet.mergeCells('A6:A7');
  worksheet.mergeCells('B6:B7');

  // Excel Data Rows
  excelObjectData.excelRowData.forEach((row) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
    });

    // Bold total rows
    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }
  });

  // Generate the Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

